export const FONT_SIZES = Object.freeze({
  tiny: '10px',
  smaller: '12px',
  small: '13px',
  default: '14px',
  medium: '18px',
  xlarge: '24px',
})
